import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import Menu from 'vibo-ui/Menu';
import Header from 'components/common/Header';
import GoBack from 'components/buttons/GoBack';
import Container from 'components/common/Container';

import { useEvent } from 'components/context/EventContext';
import { TEMPLATE_PAGE_MENU_ITEMS } from 'services/constants';
import { getSelectedTemplateMenuKeys } from 'services/common/routesHelper';

import { TemplatePageHeaderProps } from './interfaces';

import useHeaderStyles from 'components/common/Header/style';

const TemplatePageHeader: FC<TemplatePageHeaderProps> = () => {
  const headerClasses = useHeaderStyles();
  const { t } = useTranslation();

  const { event } = useEvent();

  const location = useLocation();
  const navigate = useNavigate();
  const match = useParams<{ id: string }>();

  const isTimelineActive = location.pathname.split('/').filter(Boolean)[2] === 'timeline';

  return (
    <Header>
      <GoBack
        to={isTimelineActive ? '/templates/user' : `/template/${event?._id}/timeline`}
        className={headerClasses.goBack}
      />
      <Container>
        <Menu
          getSelectedSidebarMenuKeys={getSelectedTemplateMenuKeys}
          styleModificator="siderTop"
          mode="horizontal"
        >
          {TEMPLATE_PAGE_MENU_ITEMS.map(({ name, route }) => {
            const link = `/template/${match.id}/${route}`;

            return (
              <Menu.Item onClick={() => navigate(link)} key={link}>
                {t(name)}
              </Menu.Item>
            );
          })}
        </Menu>
      </Container>
    </Header>
  );
};

export default TemplatePageHeader;
